export default {
  title: '{jobName} Referral Setup ',
  symbols: {
    cash: '￥',
    point: 'Points'
  },
  label: {
    hireNumber: 'Number of Hire(s)',
    everyHireCost: 'Reward per Hire',
    onlyEmployeeReferral: 'Non Employees Eligible for Rewards',
    hireStepCost: 'Hiring Milestones Reward',
    hireStep: {
      probation: 'Pass Probation',
      onboard: 'On Board',
      interview: 'Interviewed',
      apply: 'Applied'
    },
    referrer: {
      root: 'Starter',
      middle: 'Links in the Chain',
      direct: 'Winning Referrer'
    },
    hireType: {
      employee: 'Employee',
      notEmployee: 'Non-Employee'
    },
    referralType: {
      cash: 'Cash',
      point: 'Point',
      payroll: 'Payroll'
    },
    configStatus: {
      draft: 'Draft',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      archived: 'Archived'
    },
    configStatusActionName: {
      pending: 'Submitted',
      approved: 'Approved',
      rejected: 'Rejected',
      archived: 'Archived'
    },
    planCost: 'Planned Budget',
    actualCost: 'Actual Budget',
    postpaid: 'Post-pay',
    prepay: 'Pre-pay',
    chainTip: {
      job: 'Job',
      candidate: 'Candidate',
      root: {
        line1: 'Starter',
        line2: ''
      },
      middle: {
        line1: 'Links',
        line2: 'in the Chain'
      },
      direct: {
        line1: 'Winning',
        line2: 'Referrer'
      }
    }
  },
  btn: {
    save: 'Submit for Approval',
    saveDraft: 'Save Draft',
    backJobList: '< Return to job list'
  },
  message: {
    referralTip: {
      everyHireCost: 'Please note, AJINGA will deduct and pay 20% withholding tax for each referrer payment in compliance with PRC tax law.',
      hireStep: {
        probation: 'Click this option if you want to reward referrers after candidates pass probation.',
        onboard: 'Click this option if you want to reward referrers after candidates are on-board.',
        interview: 'Click this option if you want to reward referrers after candidates have been interviewed for the job. In the box below, input the total number of interviews for this job you would like to reward. For example, typing "10" in the box will reward the referrers of the first 10 people that interview for this job.',
        apply: ' Click this option if you want to reward referrers after candidates have applied for the job. In the box below, input the total number of applications for this job you would like to reward.  For example, typing "10" in the box will reward the referrers of the first 10 people that apply for this job.'
      },
      postpaid: 'Post-pay refers to the amount that the company will need to reward after candidates come on-board and/or pass probation. The amount listed is the maximum budget, assuming that all successful candidates come through the referral program. It is not necessary to pre-fund this amount in order to open and post a job.  However, the Post-pay amount will need to be funded and paid to successful referrers before an open job can be archived.<br/><br/>AJINGA will deduct and pay 20% withholding tax for each referrer payment in compliance with PRC tax law.',
      prepay: 'Pre-pay refers to the amount, that if selected, will be paid to referrers for successful job applications and/or interviews. Pre-pay budgets must be fully funded before a job can be posted to the referral program.  "Application" rewards will be paid to the referrer automatically upon to application. "Interview" rewards will be paid when the interview status has been updated in the system.<br/><br/>AJINGA will deduct and pay 20% withholding tax for each referrer payment in compliance with PRC tax law.'
    },
    hireNumberTooSmall: 'Number of hire(s) can not be 0',
    everyHireCostTooSmall: 'Reward per hire need greater than(or equal) 100',
    stepCostHasError: 'Please check the reward amount setting',
    actualCostTooSmall: 'Please make sure the actual budget is greater than 0',
    stepCostToolSmall: 'Reward budget in the chain, total can\'t be more than total budget. Least reward must be equal or over 2',
    stepActualCostMoreThanPlan: 'Total amount cannot exceed your budget. To add rewards, first reduce rewards elsewhere.',
    referralChainTip: {
      root: {
        name: '"Starter" ',
        info: 'This refers to the referrer who is the first individual in a successful referral chain. '
      },
      middle: {
        name: '"Links in the Chain" ',
        info: 'This refers to the individuals in the referral chain between the "Starter" and the "Winning Referrer". During a successful referral, if the actual number of referral links is less than the number selected, the reward will be allocated to "Starter".'
      },
      direct: {
        name: '"Winning Referrer" ',
        info: 'This refers to the individual who has directly referred the successful candidate.'
      }
    },
    needInputNumber: 'Please enter the correct number!',
    inputNumberMustBigger: 'Please enter a number greater than {number}!',
    inputNumberMustSmaller: 'Please enter a number less  than {number}!'
  }
}
